module.exports = __webpack_public_path__ + "static/media/spiderman.2d45eb89.jpg";